import React from 'react'
import Card from './utils/Card'
import FAQLink from './FAQLink'

const cardProps = {
  header: 'Ooops! Something went wrong!',
  text: `Either your order has already been collected or there was a problem with the application. We apologise for any inconvenience.
  You can try refreshing the application or contact us for further help.`,
  action: {
    text: 'Refresh Page',
    icon: 'refresh',
    variant: 'tertiary',
  },
  stage: 'error',
  onActionClick: () => window.location.reload(),
}

const ErrorCard = () => {
  return (
    <>
      <Card {...cardProps} dataCy="error-card" />
      <FAQLink href="/collect/faq" />
    </>
  )
}

export default ErrorCard
